import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause",
  "use": "icon-pause-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-pause\">\n<circle cx=\"16\" cy=\"16\" r=\"15.5\" stroke=\"#EFEFEF\" />\n<rect x=\"17.2931\" y=\"10.0693\" width=\"3.70692\" height=\"11.8621\" rx=\"1.85346\" fill=\"#4D4D4D\" />\n<rect x=\"11\" y=\"10.0693\" width=\"3.70692\" height=\"11.8621\" rx=\"1.85346\" fill=\"#4D4D4D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol